import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  centerBtn: {
    textAlign: "center",
    marginTop: theme.spacing(3),
  },
  successIcon: { width: 56, height: 56, marginBottom: 20 },
  titleWrapper: {
    textAlign: "center",
  },
}));
